import styled from "styled-components";

export const CustomBackground = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
`;
export const CommerceCompassStyled = styled.div`
	.custom-checkbox-sponsorProfile {
		margin: auto 0;
	}
	.thank-you-page-content {
		display: flex;
	}
	.wraper-removeButton {
		display: flex;
		flex-wrap: wrap;
	}
	@media print {
		.print {
			margin-top: 1rem;
			display: block !important;
			page-break-before: auto;
		}
		.no-print {
			display: none !important;
		}
	}

	max-width: 850px;
	margin: 0 auto;
	background: #ffffff;
	.service-available-options{
		color: #666666;
	}
	@media only screen and (max-width: 800px) {
		.text-area {
			margin-left: 0 !important;
		}
		.subtitle {
			margin-left: 0 !important;
		}
		input {
			margin-left: 0 !important;
		}
	}

	font-family: Segoe UI, Segoe WP, Tahoma, Arial, sans-serif;
	.text-format-content ol,
	.text-format-content ul {
		margin: 5px 0;
		padding-left: 30px;
	}
	option {
		color: #333;
		text-decoration: none;
		background-color: #f4f4f4;
		padding: 3px 20px 3px 15px;
		background-color: rgba(0, 0, 0, 0.002);
		background-color: #fff;
		border: 1px solid transparent;
		box-sizing: border-box;
		color: #333;
		cursor: pointer;
		display: block;
		outline: 1px solid transparent;
		padding: 3px 20px 3px 0;
		text-decoration: none;
		width: 100%;
	}

	.section-title {
		margin: 20px 20px 0;
	}

	.head-title {
		font-size: 1.3125rem;
	}

	.office-form-subtitle.heading-2 {
		font-size: 0.875rem;
		margin-top: 10px;
	}

	.text-format-content ul {
		margin: 5px 0;
		padding-left: 30px;
	}

	.subtitle {
		word-wrap: break-word;
		color: #666;
		font-style: italic;
		line-height: 1.4;
		white-space: pre-wrap;
		margin-bottom: 10px;
		&.flex {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 5px;
			button {
				margin-right: 3px;
				gap: 5;
			}
			.add-new {
				font-weight: 400;
			}
			@media only screen and (max-width: 650px) {
				.add-new {
					display: none;
				}
				button {
					gap: 0;
				}
			}
		}
	}

	.btn-submit {
		align-items: center;
		display: flex;
		flex-wrap: nowrap;
		height: 100%;
		justify-content: center;
		vertical-align: baseline;
		width: 178px;
		height: 38px;
		color: #ffffff;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.text-area {
		resize: none;
		height: 110px;
		width: 100%;
		margin-bottom: 0;
		padding: 10px 10px;
	}
	.form-item-custom {
		&:first-child {
			margin-top: 10px;
		}
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		margin-bottom: 10px;
		gap: 15px;

		@media only screen and (max-width: 800px) {
			gap: 5px;
			margin-bottom: 5px;
		}

		button {
			width: 38px;
			height: 38px;
			max-width: 38px;
			min-width: 38px;
			margin: 0;
			padding: 0;
			&.button-rm {
				background: #fff;
				color: #000;
			}
		}

		.wraper-right {
			display: flex;
			gap: 10px;
			width: 100%;
		}
		.custom-select {
			flex: 1;
			min-width: 50%;
			&.m-width-20 {
				min-width: 25%;
			}
		}
		@media only screen and (max-width: 800px) {
			
			.custom-select {
				flex: 1;
				/* min-width: 50%; */
				&.m-width-20 {
					min-width: 30%;
				}
			}
			.wraper-right {
				display: flex;
				gap: 5px;
				width: 60%;
			}
		}

		.form-item-title {
			width: 50%;
		}
	}

	.btn-upload {
		background-color: rgb(39, 129, 186);
		border-radius: 5px;
		border-radius: 5px;
		color: rgb(255, 255, 255);
		font-size: 1.07692rem;
		font-weight: 600;
		letter-spacing: 0px;
		opacity: 1;
		font-size: 0.875rem;
		width: auto;
		min-width: 50px;
		padding: 5px 15px;
		margin: 10px 10px 10px 0;
		&:hover,
		&:focus {
			background-color: rgb(31, 103, 149);
			cursor: pointer;
		}
		align-items: center;
		display: flex;
		flex-wrap: nowrap;
		-webkit-box-pack: center;
		justify-content: center;
		vertical-align: baseline;
		width: 178px;
		height: 38px;
		min-width: 178px;
		margin-left: 10px;
	}

	.upload-name {
		max-width: 120px;
		margin-left: 10px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	label.lable-upload {
		display: flex;
		align-items: center;
	}

	.btn-additional-distinct {
		align-items: center;
		display: flex;
		flex-wrap: nowrap;
		-webkit-box-pack: center;
		justify-content: center;
		vertical-align: baseline;
		width: 300px;
		height: 38px;
		color: rgb(255, 255, 255);
	}
	.custom-input {
		width: 100%;
	}
	input {
		width: 100%;
		border-radius: 5px;
		&.custom-input {
			padding: 5px 10px;
		}
		&[type="radio"] {
			width: 20px;
			margin-bottom: 0px;
			display: flex;
			align-items: center;
			justify-content: start;
			margin-right: 15px;
		}
		&[type="checkbox"] {
			width: 30px;
			margin-bottom: 0;
		}
	}

	.react-datepicker-ignore-onclickoutside {
		height: 34px;
		padding: 5px 10px;
		margin-bottom: 0;
	}

	.react-datepicker__input-container {
		input {
			height: 40px;
			padding: 5px 10px;
			margin-bottom: 0 !important;
		}
	}

	.react-datepicker-wrapper {
		width: 100%;
	}

	.label-title-cus {
		font-weight: 700;
		display: flex;
		align-items: center;
		padding: 10px 20px 8px 0px;
		word-wrap: break-word;
		color: #333;
		font-family: Segoe UI, Segoe WP, Tahoma, Arial, sans-serif;
		font-size: 0.875rem;
		line-height: 1.3;
		max-width: 100%;
		position: relative;
		white-space: pre-wrap;
		.tool-tip {
			font-size: 0.875rem !important;
			font-weight: 400;
			max-width: 300px;
			a {
				font-weight: 700;
			}
		}
		.wraptitle {
			display: flex;
			gap: 5px;
			align-items: center;
		}
		.add-new {
			font-weight: 400;
		}
		&.flex {
			padding-right: 3px;
			@media only screen and (max-width: 650px) {
				button {
					gap: 0;
				}
				.add-new {
					display: none;
				}
			}
		}

		&.tow-col-label {
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 5px;
			input[type="checkbox"] {
			}
		}
		&.pb-0 {
			padding-bottom: 0 !important;
		}
	}

	.label-title {
		padding: 20px 3px 8px 0px;
		display: flex;
		align-items: center;
		word-wrap: break-word;
		color: #333;
		font-family: Segoe UI, Segoe WP, Tahoma, Arial, sans-serif;
		font-size: 0.875rem;
		line-height: 1.3;
		max-width: 100%;
		position: relative;
		white-space: pre-wrap;
		font-weight: 700;
		.tool-tip {
			font-size: 0.875rem !important;
			font-weight: 400;
			max-width: 300px;
			a {
				font-weight: 700;
			}
		}
		.wraptitle {
			display: flex;
			gap: 5px;
			align-items: center;
		}
		.add-new {
			font-weight: 400;
		}
		@media only screen and (max-width: 650px) {
			button {
				gap: 0;
			}
			.add-new {
				display: none;
			}
		}

		&.tow-col-label {
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 5px;
			input[type="checkbox"] {
			}
		}
		&.pb-0 {
			padding-bottom: 0 !important;
		}
	}

	form {
		padding: 0px 20px;
		@media only screen and (max-width: 650px) {
			padding: 0px 10px;
		}
	}

	.toggle {
		background: #ffffff;
		border-radius: 9999px;
	}

	.react-datepicker-wrapper {
		input {
			margin-left: 0;
			height: 34px;
			padding: 5px 10px;
		}
	}

	.office-form-subtitle {
		ul {
			margin: 5px 0;
			padding-left: 30px;
			list-style: unset;
		}
	}

	.toggle {
		input:checked + div {
			background-color: rgb(39, 129, 186) !important;
		}
		input:focus + div {
			box-shadow: none;
		}
	}
	.required {
		display: flex;
		color: #ae1515;
		font-size: 0.9375rem;
		gap: 5px;
	}

	.error {
		.css-13cymwt-control {
			border-color: #ae1515;
		}
		color: #ae1515;
		&.text-area {
			border: 1px solid #ae1515;
			border-radius: 5px;
		}
	}

	.header {
		color: #fff;
		margin: -30px;
		position: relative;
		.office-form-title {
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			left: 40px;
		}
		@media only screen and (max-width: 800px) {
			margin: 0;
			margin-top: -30px;
			font-size: 1.6875rem;
			.office-form-title {
				left: 20px;
				span {
					display: block;
				}
			}
		}

		margin-bottom: 40px;
		font-size: 2.375rem;
		img {
			margin-bottom: 20px;
		}
	}

	.submmit-another {
		color: rgb(12, 100, 192);
	}
`;

export const AGButtonPrimary = styled.button`
	background-color: rgb(39, 129, 186);
	border-radius: 5px;
	border-radius: 5px;
	color: rgb(255, 255, 255);
	font-size: 1.07692rem;
	font-weight: 600;
	letter-spacing: 0px;
	opacity: 1;
	font-size: 0.875rem;
	width: auto;
	min-width: 50px;
	padding: 5px 15px;
	margin: 10px 10px 10px 0;
	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}

	&:hover,
	&:focus {
		background-color: rgb(31, 103, 149);
	}
	&.return {
		margin-right: 0px;
		margin-left: auto;
		padding: 10px 15px;
		display: block;
		margin-top: 0;
	}
`;

export const AGButton = styled.button`
	border-radius: 5px;
	border-radius: 5px;
	font-size: 1.0769rem;
	font-weight: 600;
	letter-spacing: 0px;
	opacity: 1;
	font-size: 0.875rem;
	width: auto;
	min-width: 50px;
	padding: 5px 15px;
	margin: 10px 10px 10px 0;
	&:hover,
	&:focus {
		background-color: rgb(218, 218, 218);
	}
	&.btn-cancel {
		align-items: center;
		display: flex;
		flex-wrap: nowrap;
		height: 100%;
		justify-content: center;
		vertical-align: baseline;
		width: 178px;
		height: 38px;
		color: black;
		margin-top: 20px;
		margin-bottom: 20px;
		background: #d9d9d9;

		&:hover {
			background: #a8a8a8;
		}
	}
`;

export const ModalHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 60px;
	border-bottom: 1px solid #cccccc;
	padding: 0px 15px;
	.title {
		font-size: 1rem;
		font-weight: 700;
	}
`;

export const ModalBody = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	.title {
		font-size: 1rem;
		font-weight: 700;
	}
	overflow-y: auto;
	position: relative;
	height: calc(100% - 120px);
	width: 100%;
`;
export const ModalFooter = styled.div`
	border-top: 1px solid #cccccc;
	padding: 0px 20px;
	display: flex;
	align-items: center;
	justify-content: end;
	gap: 10px;
	height: 60px;
`;
